/*------------------------------------*\
    HEADER
\*------------------------------------*/
class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        self.dropdowns();
        self.navToggle();
        self.sticky();
    }

    navToggle() {
        let self = this;

        const toggle = document.querySelector('[data-nav-toggle]');
        const nav = document.querySelector('[data-nav]');
        const header = document.querySelector('[data-nav-header]');

        toggle.addEventListener('click', evt => {
            evt.preventDefault();
            nav.classList.toggle('is-open');
            toggle.classList.toggle('is-open');
            header.classList.toggle('is-open');
        });
    }

    dropdowns() {
        let self = this;

        const dropdowns = self.elem.querySelectorAll('[data-nav-dropdown]');

        dropdowns.forEach(elem => {
            let trigger = elem.querySelector('[data-nav-dropdown-trigger]');
            let dropdown = elem.querySelector('[data-nav-dropdown-menu]');

            trigger.addEventListener('click', evt => {
                evt.preventDefault();

                dropdown.classList.toggle('is-open');
                trigger.classList.toggle('is-active');
            });

            // Listen for clicks outside of this nav element and
            // close the dropdown
            document.addEventListener('click', evt => {
                if (!elem.contains(evt.target)) {
                    dropdown.classList.remove('is-open');
                    trigger.classList.remove('is-active');
                }
            });
        });
    }

    sticky() {
        let self = this;

        window.addEventListener('scroll', function() {
            const scroll = window.pageYOffset | document.body.scrollTop;
            const main = document.getElementById('main');

            if (scroll > 0) {
                self.elem.classList.add('scrolled');
                main.classList.add('scrolled');
            } else if (scroll <= 0) {
                self.elem.classList.remove('scrolled');
                main.classList.remove('scrolled');
            }
        });
    }
}

export default Header;
